import { useEffect } from "react";

/**
 * Tytul karty przegladarki dla widoku: ustawia go na czas zycia komponentu i oddaje poprzedni przy odmontowaniu.
 * Czytnik ekranu i historia przegladarki opieraja sie na tytule, a jeden tytul na wszystkie strony nie mowi, gdzie
 * recenzent jest. `null` oznacza "jeszcze nie wiadomo" (np. dane sie wczytuja): tytul zostaje bez zmian.
 *
 * Tylko liscie drzewa tras ustawiaja tytul, wiec dwa efekty nigdy nie walcza o to samo pole.
 */
export function useTytulStrony(tytul: string | null): void {
  useEffect(() => {
    if (tytul === null) return;
    const poprzedni = document.title;
    document.title = tytul;
    return () => {
      document.title = poprzedni;
    };
  }, [tytul]);
}

/** "Recenzja: Kazimierz Nalepa - ConvoLens": strona glowna linku. */
export const tytulListyRecenzji = (etykieta: string): string => `Recenzja: ${etykieta} - ConvoLens`;

/** "2026-07-30 - Recenzja": strona jednej rozmowy. */
export const tytulRozmowyRecenzji = (tytulRozmowy: string): string => `${tytulRozmowy} - Recenzja`;
